import TurnDto from '../Dtos/TurnDto';

export class GetTurnResponse {
    static Message = 'GetTurnResponse';

    public turn: TurnDto;

    constructor(turn: TurnDto) {
        this.turn = turn;
    }
}
